import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addDoctor } from "../api/add-doctor";

export const useAddDoctor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addDoctor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["doctors"] });
    },
  });
};
